import * as React from 'react';
import i18n from 'i18n-react';
import * as moment from 'moment';
import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import Button from '../../../../components/button/Button';
import { Status, FareOriginType } from '../../../../const/PNRItemModel';
import './HeaderPNRTrackerContainer.css';
import { StatusAntiFraud } from '../../../../const/CancelModel';
import { map } from 'lodash';

const propTypes = {
  pnrItem: PropTypes.any,
  hideBackButton: PropTypes.any,
  hideCancelButton: PropTypes.any,
  hideChangeTrip: PropTypes.any,
  goBack: PropTypes.any,
  refundClient: PropTypes.any,
  simulateCancel: PropTypes.any,
  handleCancel: PropTypes.any,
  handleChangeTrip: PropTypes.any
};

class HeaderPNRTrackerContainer extends React.Component {
  render() {
    const isPublicFareOrigin = this.props.pnrItem.fareOriginType === FareOriginType.PUBLIC;
    const typeOfFare = isPublicFareOrigin
      ? i18n.translate('features.pnrItemContainer.typeOfFarePublicNoAcoradouro')
      : i18n.translate('features.pnrItemContainer.typeOfFareAward');

    return (
      <div className="HeaderPNRTrackerContainer">
        <Row>
          <Col className="text-300 HeaderPNRTrackerContainer__numberAndStatusPnr" span={13}>
            <Col className="HeaderPNRTrackerContainer__pnrContainer" span={11}>
              {i18n.translate('features.pnrItemContainer.tracker')}
              <br />
              <b className="text-500 HeaderPNRTrackerContainer__pnrNumber" data-test="pnr">
                {this.props.pnrItem.pnrNumber}
              </b>
            </Col>
            <Col>{this.renderAntiFraud()}</Col>
          </Col>
          <Col className="d-table" span={11}>
            <Row className="HeaderPNRTrackerContainer__buttonContainer">
              <Col className="text-right" span={16}>
                {!this.props.hideBackButton ? (
                  <Button
                    name="returnToSearchResult"
                    className="text-xl HeaderPNRTrackerContainer__returnToSearchResult margin-eight-right-24"
                    background="navy-blue"
                    disabled={false}
                    onClick={() => window.history.back()}>
                    {i18n.translate('label.back')}
                  </Button>
                ) : (
                  ''
                )}
              </Col>
              <Col className="text-right" span={8}>
                {!this.props.hideChangeTrip ? (
                  <Button
                    name="changeTrip"
                    className="text-xl HeaderPNRTrackerContainer__cancelTrip  margin-eight-bottom-24"
                    background="navy-blue"
                    disabled={
                      (this.props.pnrItem.status !== Status.ACTIVE &&
                        this.props.pnrItem.status !== Status.REALLOCATION) ||
                      this.props.pnrItem.statusAntiFraud !== StatusAntiFraud.APA
                    }
                    onClick={this.props.handleChangeTrip}>
                    {i18n.translate('features.pnrItemContainer.changeTrip')}
                  </Button>
                ) : (
                  ''
                )}

                {!this.props.hideCancelButton ? (
                  <Button
                    name="cancelTrip"
                    className="text-xl HeaderPNRTrackerContainer__cancelTrip margin-eight-bottom-24"
                    background="navy-blue"
                    disabled={
                      this.props.pnrItem.status !== Status.ACTIVE &&
                      this.props.pnrItem.status !== Status.REALLOCATION
                    }
                    onClick={this.props.handleCancel}>
                    {i18n.translate('features.pnrItemContainer.cancelTrip')}
                  </Button>
                ) : (
                  ''
                )}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className={'HeaderPNRTrackerContainer__rowSectionPnr'}>
          <Col span={4} className="HeaderPNRTrackerContainer__pnrInfo text-400">
            <span className="HeaderPNRTrackerContainer__pnrInfo HeaderPNRTrackerContainer__pnrInfo__label">
              {i18n.translate('context.pnrDetailPage.reservationDate')}
            </span>
            <br />
            <span className="HeaderPNRTrackerContainer__pnrInfo HeaderPNRTrackerContainer__pnrInfo__value">
              {moment(this.props.pnrItem.pnrDate).format('DD/MM/YYYY')}{' '}
              {moment(this.props.pnrItem.pnrDate).format('HH:mm')}
            </span>
          </Col>

          <Col span={6} className="HeaderPNRTrackerContainer__typeOfFare">
            <span className="HeaderPNRTrackerContainer__pnrInfo HeaderPNRTrackerContainer__pnrInfo__label">
              {i18n.translate('features.pnrItemContainer.typeOfFare')}
            </span>
            <br />
            <span className="HeaderPNRTrackerContainer__pnrInfo HeaderPNRTrackerContainer__typeFare HeaderPNRTrackerContainer__pnrInfo__value">
              {typeOfFare}
            </span>
          </Col>
        </Row>
        <Row>{this.getStatusAntiFraud()}</Row>
      </div>
    );
  }

  renderAntiFraud() {
    let element = null;
    let statusAntiFraud = i18n.translate('label.statusAntiFraud.pdt').toString();
    let statusClassName = 'HeaderPNRTrackerContainer--statusOthers';
    switch (this.props.pnrItem.statusAntiFraud) {
      case StatusAntiFraud.APA:
        statusAntiFraud = i18n.translate('label.statusAntiFraud.apa').toString();
        statusClassName = 'HeaderPNRTrackerContainer--statusActive';
        break;
      case StatusAntiFraud.FRD:
        statusAntiFraud = i18n.translate('label.statusAntiFraud.frd').toString();
        statusClassName = 'HeaderPNRTrackerContainer--statusCanceled';
        break;
      case null:
      case StatusAntiFraud.PDT:
      default:
        statusAntiFraud = i18n.translate('label.statusAntiFraud.pdt').toString();
        statusClassName = 'HeaderPNRTrackerContainer--statusReallocation';
        break;
    }

    element = (
      <Col
        className="text-xl HeaderPNRTrackerContainer__statusPnr"
        data-test="statusAntiFraudContainer"
        span={12}>
        <span className="text-400">
          {i18n.translate('features.pnrItemContainer.statusAntiFraud')}
        </span>{' '}
        <b className={`text-500 ${statusClassName}`} data-test="statusAntiFraud">
          {statusAntiFraud}
        </b>
      </Col>
    );
    return element;
  }

  renderPartnerPnr() {
    const partnerPnrMap = this.props.pnrItem.partnerPnrMap;
    const partnerPnrArray = partnerPnrMap ? Object.entries(partnerPnrMap) : [];
    if (partnerPnrArray.length > 0) {
      return (
        <Row className="HeaderPNRTrackerContainer__partnerPnr">
          {partnerPnrArray.map(([key, val], i) => (
            <Col key={key} className="HeaderPNRTrackerContainer__partnerPnr_item" span={24}>
              <div className="text-400">
                <div className="HeaderPNRTrackerContainer__pnrInfo HeaderPNRTrackerContainer__pnrInfo__label">
                  {this.getCompanyName(key)}{' '}
                  {i18n.translate('features.pnrItemContainer.partnerPnr')}{' '}
                  <b className="HeaderPNRTrackerContainer__pnrInfo HeaderPNRTrackerContainer__typeFare HeaderPNRTrackerContainer__pnrInfo__value">
                    {val}
                  </b>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      );
    }
    return null;
  }

  getCompanyName(company) {
    if (
      i18n
        .translate(`company.${company}`)
        .toString()
        .substring(0, 8) === 'company.'
    ) {
      return company;
    } else {
      return i18n.translate('company.' + company);
    }
  }

  getStatusAntiFraud() {
    if (this.props.pnrItem.statusAntiFraud === StatusAntiFraud.APA) {
      return this.renderPartnerPnr();
    }
    return null;
  }
}

HeaderPNRTrackerContainer.propTypes = propTypes;

export default HeaderPNRTrackerContainer;



// WEBPACK FOOTER //
// ./src/page/flightDetailsPage/components/headerPNRTracker/HeaderPNRTrackerContainer.jsx